export default {
	data(){
		return {
			tableGBoptions: { 
				options: {eliminar: 'Eliminar cita'},
				modals: [
					{
					  "modal": "examen",
					  "icon": "list-check",
					  "title": "Examen de Optometría"
					},
				]
			},

			tableGBSearch: ['datos_pacientes/name','datos_pacientes/documento'],
			
			tableGBItems: [
				{
					thead: { th: 'Nombre Paciente', sort: null, sortTable: 'datos_pacientes/name'},
					tbody: { td: ['datos_pacientes/name']}
				},
				{
					thead: { th: 'Evaluación'},
					tbody: { td: ['info_agendas/evaluacion'],}
				},
				{
					thead: { th: 'Historial'},
					tbody: { table: {
						value: false,
						tabla: "info_orden",
						search: [
						  "fecha_entrega"
						],
						options: {
						  save: "garantia"
						},
						items: [
						  {
							thead: { th: "Fecha" },
							tbody: { td: [ "fecha_entrega" ] }
						  },
						  {
							thead: { th: "Exámen"},
							tbody: { td: [ "id_info_examens" ], link: '/api/pdf/examen' }
						  },
						  {
							thead: { th: "Diagnostico"},
							tbody: { td: [ "id" ], link: '/api/pdf/diagnosticos' }
						  },
						]
					  }
					}
				}
			]
			
		}
	},
}